/*
 * Pauses a section's background video while its popup video plays, so the
 * loop behind the popup doesn't pull the eye, and resumes it on close.
 *
 * The theme opens the popup (PhotoSwipe) from [data-video-play]; the popup's
 * root carries `pswp--open` while it is shown, which is what we watch.
 */
(function () {
  if (window.videoPopupPause) return;
  window.videoPopupPause = true;

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-video-play]');
    if (!trigger || !trigger.getAttribute('data-video-play').trim()) return;

    const section = trigger.closest('[data-section-type]');
    if (!section) return;

    const paused = Array.prototype.filter.call(section.querySelectorAll('video'), function (video) {
      if (video.paused) return false;
      video.pause();
      return true;
    });
    if (!paused.length) return;

    // Resume once the popup has opened and then closed again.
    let opened = false;
    const observer = new MutationObserver(function () {
      const isOpen = document.querySelector('.pswp.pswp--open') !== null;
      if (isOpen) {
        opened = true;
      } else if (opened) {
        observer.disconnect();
        paused.forEach(function (video) {
          video.play().catch(function () {});
        });
      }
    });
    document.querySelectorAll('.pswp').forEach(function (popup) {
      observer.observe(popup, { attributes: true, attributeFilter: ['class'] });
    });
  });
})();
